import React from 'react'
import {Link} from 'react-static'
import {connect} from 'react-redux'
import SignUpForm from '../components/SignUpForm'
import Spinner from '../components/Spinner'
import ActivateAccount from '../components/ActivateAccount'
import {
  createUserWithEmailAndPassword,
  sendEmailVerification
} from '../actions/account'

const SignUp = ({authUser,isFetching}) =>
  <React.Fragment>
    <div className="text-center m-b-20">
      <Link to="/" className="logo-lg">
        <img src="logo_light_32.png" alt="logo"/>{' '}
        <span>ColorRibbon</span>
      </Link>
    </div>
    {isFetching
      ?
      <Spinner/>
      :
      (authUser
        ?
        <React.Fragment>
          <p className="text-success">Sie haben sich erfolgreich registriert.</p>
          {!authUser.emailVerified &&
            <ActivateAccount email={authUser.email}/>
          }
        </React.Fragment>
        :
        <SignUpForm
          signup={createUserWithEmailAndPassword}
          sendEmailVerification={sendEmailVerification}/>
      )
    }

  </React.Fragment>

export default connect(
  state => ({
    authUser: state.account.authUser,
    isFetching: state.account.isFetching
  })
)(SignUp)



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/containers/SignUp.js